export var createL7Icon = function createL7Icon(className) {
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.classList.add('l7-iconfont');
  svg.setAttribute('aria-hidden', 'true');
  var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
  use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', "#".concat(className));
  svg.appendChild(use);
  return svg;
};